import auth from '@/commons/authService';
import commonFn from '@/commons/commonFunction';
import popupUtil from '@/commons/popupUtil';
import { loadLanguageAsync } from '@/i18ns/i18n';
import { ModuleContext } from '@/stores/moduleConst';
import store from '@/stores/store';
import { createRouter, createWebHistory } from 'vue-router';
import routerPage from './routerPage';
import webSocket from '@/sockets/socket';
import { POPUP } from '@/constants/index';

const routes = [
  {
    path: '',
    redirect: '/dashboard',
  },
  ...routerPage,
  {
    // Redirect to 404 page, if no match found
    path: '/:pathMatch(.*)*',
    component: () => import(/*webpackChunkName:'pages'*/ '@/pages/404.vue'),
    meta: {
      data: {},
      anonymous: true,
    },
  },
];

// let routerOnReady = function () {};

// let routerOnError = function () {
//   // commonFunc.errorLogging(error);
// };

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// router.onError((error) => {
//   const pattern = /Loading chunk (\S)+ failed/g;
//   const isChunkLoadFailed = error.message.match(pattern);
//   if (isChunkLoadFailed && window._appConfig.showLoadChunkFail) {
//     messageBox.showError(i18n.t("i18nSY.LoadChuckFail")).then(() => {
//       window.location.reload();
//     });
//   }
// });

// router.onReady(routerOnReady, routerOnError);

router.afterEach(async (to, from, next) => {
  try {
    if (store && store.state && store.state.context && store.state.context.User && store.state.context.User.UserName) {
      if (
        to.name != 'Login' &&
        (!webSocket._connection || (webSocket._connection && webSocket._connection.state != 'Connected'))
      ) {
        // store.dispatch('context/initConnectSocket', store.state.context);
      }
      //hiển thị popup thiết lập 2fa
      if (store.state.context.User.Force2FASetup) {
        store.commit('popup/SHOW_POPUP', {
          type: POPUP.TWO_FACTOR_AUTH,
          data: {},
        });
      }
    }
  } catch {}
  commonFn.unmask();
});

router.beforeEach(async (to, from, next) => {
  //tam thoi comment vao
  // nếu bắt đầu là request-page hay liceses-page đích tới là những path dưới thì k reset
  let pathFrom = ['license-page', 'request-page'];
  let pathsBreak = ['license-upgrade', 'license-extend', 'license-purchase', 'update-request', 'approve-request'];

  let pathUpdate = ['license-upgrade', 'license-extend', 'license-purchase'];

  let flag = pathFrom.some((item) => from.fullPath.includes(item));
  if (flag) {
    flag = pathsBreak.some((item) => to.fullPath.includes(item));
    if (!flag) {
      store.commit('context/clearCachePaging');
      to.meta.data.isclear = true;
    } else {
      to.meta.data.isclear = false;
    }
  } else {
    // đầu router k reset lại cache paging
    flag = pathsBreak.some((item) => from.fullPath.includes(item));
    if (!flag) {
      store.commit('context/clearCachePaging');
      to.meta.data.isclear = true;
    } else {
      flag = pathUpdate.some((item) => from.fullPath.includes(item));
      if (flag && to.fullPath.includes('request-page')) {
        store.commit('context/clearCachePaging');
        to.meta.data.isclear = true;
      }
      to.meta.data.isclear = false;
    }
  }

  let lang = store.state[ModuleContext]?.Context?.Culture || 'en-US';
  await loadLanguageAsync(lang);

  store.commit('popup/HIDE_POPUP');
  store.commit('dialog/HIDE_DIALOG');

  //khi chuyển router sẽ show maskloading cho người dùng biết xử lý
  //do tình huông tải file js chậm
  //trong after sẽ ẩn mask loading đi
  //Tạm thời dùng loading global, sau này có thể làm kiểu thanh line chạy ngay dưới address bar sau
  commonFn.mask();
  //hide all popup
  //TODO => Ẩn tất cả popup ở đây
  popupUtil.hideAll();

  //trang không authen
  if (to.meta.anonymous) {
    next();
    return;
  }
  // // thực hiện lưu thông tin misa id vào localstorage
  // if (
  //   'code' in to.query &&
  //   'session_state' in to.query &&
  //   'scope' in to.query &&
  //   'state' in to.query
  // ) {
  //   var code = to.query.code;
  //   var scope = to.query.scope;
  //   var state = to.query.state;
  //   var client = JSON.parse(
  //     localStorage.getItem(window._misaId.client_id) //Thay chuỗi Guid bằng Clientid
  //   );
  //   const data = {
  //     scope: scope,
  //     grant_type: 'authorization_code',
  //     redirect_uri: client?.redirect_uri,
  //     code: code,
  //     code_verifier: client?.code_verifier,
  //   };
  //   if (state === client?.state) {
  //     try {
  //       var res = await accountAPI.getMisaIDToken(data);
  //       if (res.Data.token) {
  //         let licenseToken = JSON.parse(
  //           localStorage.getItem('license_cukcuk') || ''
  //         );
  //         if (licenseToken) {
  //           licenseToken.context.Token = res.Data?.token;
  //           licenseToken.context.TokenExpired = new Date().addSeconds(
  //             res.Data?.tokenTimeout
  //           );
  //           licenseToken.context.User = res.Data?.user;
  //           licenseToken.context.Permission = null;
  //           licenseToken.context.PostedDate = new Date();
  //           localStorage.setItem(
  //             'license_cukcuk',
  //             JSON.stringify(licenseToken)
  //           );
  //         }
  //         store.commit('context/updateToken',res?.Data);

  //         window.alert('Đăng nhập MisaID thành công');
  //       }
  //       if (res && res.Data && res.Data.user) {
  //         window.sessionStorage.setItem(
  //           'role-license',
  //           JSON.stringify(res.Data.user)
  //         );
  //       }
  //     } catch {
  //       window.alert('Đăng nhập MisaID thất bại');
  //       window.location.href = MisaID.Logout();
  //       return;
  //     }
  //   }
  // }

  //kiểm tra authen -> fail redirect login
  if (!auth.isAuthenticated()) {
    auth.login(next());
    commonFn.unmask();
    return;
  }

  //default
  next();
});

export default router;
